import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Component, OnInit, HostListener } from '@angular/core';
import { Observable, Subscriber, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PreloaderService } from 'modules/shared/legacy-bookexpress/services/preloader.service';
import { CpinService } from 'modules/shared/legacy-bookexpress/services/cpin.service';
import { RGuestMessages } from 'app/model/shared/backend-api-response/rguest-messages';
import { CasinoPlayerService } from '../../services/casino-player.service';
import { ToastrService } from 'ngx-toastr';
import { TrackidleService } from '../../services/trackidle.service';

@Component({
  selector: 'app-cpin',
  templateUrl: './cpin.component.html',
  styleUrls: ['./cpin.component.scss'],
})
export class CpinComponent implements OnInit {
  @ViewChild('iframe') iframe: ElementRef;
  public casinoNumber;
  private token;
  public iframeURL;
  public preload: boolean = false;
  public tenantId;
  public iFrameLoaded: boolean = true;
  public iFrameData: any;
  public message;
  public casioToken_server_name: string = '';
  rGuestBookMessages: RGuestMessages;
  public casinoToken_property_name: string = '';
  public propertyId;
  public cPin: string;
  errorMessage = '';
  requestFrom = '';
  primaryColor = '';
  constructor(
    private dialogRef: MatDialogRef<CpinComponent>,
    private _http: HttpClient,
    public snackBar: MatSnackBar,
    public CpinService: CpinService,
    @Inject(MAT_DIALOG_DATA) data,
    public PreloaderService: PreloaderService,
    public AppInitializer: LegacyBookInitService,
    public casinoService: CasinoPlayerService,
    public toastrService: ToastrService,
    private http: HttpClient,
    public track_idle: TrackidleService
  ) {
    this.preload = true;
    this.casioToken_server_name = this.AppInitializer.getcasioToken_server_name();
    this.casinoToken_property_name = this.AppInitializer.PropertyData.PropNameKeyList.validCasino;
    this.casinoNumber = data.casinoNumber;
    this.rGuestBookMessages = this.AppInitializer.PropertyData.rGuestMessages;
    this.tenantId = this.AppInitializer.tenantId;
    this.propertyId = this.AppInitializer.propertyId;
    if (data.message) {
      this.message = data.message;
    }
    this.requestFrom = data.triggerFrom || '';
  }

  ngOnInit() {
    this.casinoService.ValidateCasinoPlayer(this.casinoNumber).subscribe(
      (result) => {
        console.log('Casino Player ' + this.casinoNumber + ' token is ' + result['token']);
        this.token = result['token'];

        this.processCpinTheme();
      },
      (err) => {
        this.dialogRef.close('closed');
      }
    );
  }

  processCpinTheme() {
    let cpinStylesUrl = this.AppInitializer.PropertyData.UrlMap.cpinStylesUrl
      ? this.AppInitializer.PropertyData.UrlMap.cpinStylesUrl + '?' + this.AppInitializer.azureBlobTokenKey
      : this.AppInitializer.PropertyData.UrlMap.cpinStylesUrl;
    this.http
      .get(cpinStylesUrl, { responseType: 'text' })
      .toPromise()
      .then(
        (res) => {
          const head = document.head || document.getElementsByTagName('head')[0];
          let styleTag = document.createElement('style');
          styleTag.type = 'text/css';
          styleTag.id = 'cpinstyles';
          styleTag.textContent = '#cpinFrame {' + res + '}';
          head.appendChild(styleTag);
          this.setInputFieldColor(res);

          this.preload = false;
          let element = document.getElementById('cpin-element');
          if (this.requestFrom === 'GUESTINFO' && element) {
            this.addEventListener(element);
          }
        },
        (err) => {
          this.preload = false;
        }
      );
  }

  setInputFieldColor(cssContent) {
    console.log(cssContent);
    let res = cssContent?.split('background-image')?.[1]?.split('#')?.[1]?.split(' ')?.[0] || '';
    if (res) {
      this.primaryColor = '#' + res;
      console.log(this.primaryColor);
      let mapCss = `.mat-form-field.mat-focused .mat-form-field-label{ color: ${this.primaryColor} !important } .mat-form-field-underline{ background-color: ${this.primaryColor} !important }  .mat-form-field-ripple{ background-color: ${this.primaryColor} !important }`;

      const head = document.head || document.getElementsByTagName('head')[0];
      let styleTag = document.createElement('style');
      styleTag.type = 'text/css';
      styleTag.id = 'custom-cpin-styles';
      styleTag.textContent = '#cpinFrame {' + mapCss + '}';
      head.appendChild(styleTag);
    }
  }

  addEventListener(element) {
    let events = ['mousemove', 'mousedown', 'keypress', 'DOMMouseScroll', 'mousewheel', 'touchmove', 'MSPointerMove'];
    events.forEach((event) => {
      element.addEventListener(
        event,
        () => {
          if (this.track_idle.timerStarted) this.track_idle.start();
        },
        false
      );
    });
  }

  getErrorMessage(statusCode) {
    const error = this.AppInitializer?.PropertyData?.rGuestMessages?.errorMessages || {};
    return error[statusCode] || '';
  }

  validatePin() {
    this.preload = true;
    this.errorMessage = '';
    if (this.cPin) {
      this.casinoService.validatePin(this.cPin, this.token).subscribe(
        (result: any) => {
          if (result.ErrorMessage) {
            this.preload = false;
            this.errorMessage = this.getErrorMessage(result.StatusCode) || result.ErrorMessage;
          } else {
            if (this.requestFrom !== 'GUESTINFO') {
              let data = {
                casinoNumber: this.casinoNumber,
                token: result.xToken,
                loyaltyToken: result.loyaltyToken,
              };
              localStorage.setItem(this.tenantId + '-' + this.propertyId + '-Casino', JSON.stringify(data));
              localStorage.setItem(this.tenantId + '-' + this.propertyId + '-userLoggedIn', JSON.stringify(data));
              let casData = {
                casinoNumber: this.casinoNumber,
                count: 1,
                token: result.xToken,
                sessionts: new Date().getTime(),
                loyaltyToken: result.loyaltyToken,
              };
              if (result.loyaltyToken) {
                this.casinoService.primaryPlayerLoyaltyToken = result.loyaltyToken;
                localStorage.setItem(this.tenantId + '-' + this.propertyId + '-LoyaltyToken-' + this.casinoNumber, result.loyaltyToken);
                clearInterval(this.casinoService.primaryCasinoPlayerTokenInterval);
                this.casinoService.primaryCasinoPlayerTokenInterval = setInterval(() => {
                  this.casinoService.getLoyaltyToken();
                }, 12 * 60 * 1000);
              }
              this.CpinService.casinoTokenValidatios(casData);
              this.dialogRef.close('success');
              this.preload = false;
            } else {
              this.dialogRef.close({ status: 'success', result: result });
            }
          }
        },
        (error) => {
          console.log(error);
          if (this.requestFrom !== 'GUESTINFO') {
            this.errorMessage = this.rGuestBookMessages.profile.ProfileErrorText2;
            this.preload = false;
            console.log(JSON.parse(JSON.stringify(error)));
            this.toastrService.error(
              this.rGuestBookMessages.profile.ProfileErrorText3 || 'Something went wrong. Please revalidate your casino Id to continue.'
            );
            this.dialogRef.close('closed');
          } else {
            this.dialogRef.close({ status: 'error' });
          }
        }
      );
    } else {
      this.preload = false;
      this.errorMessage = this.rGuestBookMessages.profile.profileErrorText1;
    }
  }

  closeBtn() {
    this.preload = false;
    this.dialogRef.close('closed');
  }
}
